/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_DurationInputs */

const en_form_duration = /** @type {(inputs: Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration (minutes)`)
};

const he_form_duration = /** @type {(inputs: Form_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`משך (בדקות)`)
};

/**
* | output |
* | --- |
* | "Duration (minutes)" |
*
* @param {Form_DurationInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const form_duration = /** @type {((inputs?: Form_DurationInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_DurationInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_duration(inputs)
	return he_form_duration(inputs)
});